import { useState } from 'react';
import { StanCard } from '@/components';
import { PUBLIC_RESOURCES } from '@/lib/constants';
import { VideoModal } from './VideoModal';
import { createIconElement } from '@/lib/utils/createIconElement';
import PlayIconSvg from '@/assets/icons/ic-play-fill.svg';

const PlayIcon = createIconElement(PlayIconSvg, { className: 'size-16 text-white drop-shadow-lg' });

export const ReferralsHeader = () => {
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    const handlePlayVideo = () => {
        setIsVideoModalOpen(true);
    };

    const handleCloseVideo = () => {
        setIsVideoModalOpen(false);
    };

    return (
        <StanCard className='w-full'>
            <div className='flex w-full flex-col items-start justify-between gap-8 md:flex-row md:items-center'>
                <div className='flex flex-col gap-4'>
                    <h1 className='text-dark text-title-display-2'>
                        Earn 20% lifetime commission for each referral. No really.
                    </h1>
                    <p className='text-gray text-body-lg'>
                        Hear from Lauren why referring Stan to your followers is a win-win for everyone. For you, and
                        for your audience.
                    </p>
                </div>

                <div className='aspect-[16/9] w-full max-w-[500px] shrink-0'>
                    <div
                        className='relative h-full w-full cursor-pointer overflow-hidden rounded-lg transition-transform hover:scale-[1.02]'
                        onClick={handlePlayVideo}
                    >
                        <img
                            src={PUBLIC_RESOURCES.REFERRALS_VIDEO_THUMBNAIL}
                            alt='The secret about referrals - Video thumbnail'
                            className='aspect-[16/9] w-full rounded-lg object-cover'
                        />
                        <div className='absolute inset-0 flex items-center justify-center bg-black/20 transition-opacity hover:bg-black/30'>
                            {PlayIcon}
                        </div>
                    </div>
                </div>
            </div>

            <VideoModal
                isOpen={isVideoModalOpen}
                onClose={handleCloseVideo}
                videoUrl={PUBLIC_RESOURCES.REFERRALS_VIDEO_URL}
            />
        </StanCard>
    );
};
